"use clent";

import React from "react";
import "./styles.css";
import "../common.css";

export const FeatureCard = ({
	title,
	text,
	textColor = "#FFF",
	backgroundColor = "#1F1F1F",
	picture,
}) => {
	return (
		<div
			className="feature__card"
			style={{ color: textColor, backgroundColor: backgroundColor }}
		>
			<div>
				<div className="feature__cardtitle">{title}</div>
				<div className="feature__cardtext">{text}</div>
			</div>

			<img src={picture} alt="" className="feature__cardpic" />
		</div>
	);
};
